import { Injectable, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import {
  confirmResetPassword,
  resendResetPasswordCode,
  resetPassword,
  resetPasswordRestoreInitialState,
  sendResetPasswordCode,
} from './reset-password.actions';
import { ResetPasswordState } from './reset-password.reducer';
import {
  selectResetPasswordArguments,
  selectResetPasswordError,
  selectResetPasswordProcessing,
  selectResetPasswordResendingCode,
  selectResetPasswordSended,
} from './reset-password.selectors';

@Injectable({
  providedIn: 'root',
})
export class ResetPasswordFacade {
  #store: Store<ResetPasswordState> = inject(Store);
  isSended = toSignal(this.#store.select(selectResetPasswordSended));
  isProcessing = this.#store.select(selectResetPasswordProcessing);
  resending = this.#store.select(selectResetPasswordResendingCode);
  error$ = this.#store.select(selectResetPasswordError);
  resetPasswordArguments$ = this.#store.select(selectResetPasswordArguments);

  resetPassword(data: {
    password: string;
    username: string;
    attributeKey: string;
  }) {
    this.#store.dispatch(resetPassword(data));
  }
  init() {
    this.#store.dispatch(resetPasswordRestoreInitialState());
  }
  confirmSendCode() {
    this.#store.dispatch(sendResetPasswordCode());
  }

  resendConfirmSendCode() {
    this.#store.dispatch(resendResetPasswordCode());
  }

  confirmResetPassword(code: string) {
    this.#store.dispatch(confirmResetPassword({ code }));
  }
}
